import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import WireDetailsModal from '../../TransactionsPage/WireDetailsModal';
import {StyledAddFundsDetailsButton} from './StyledAddFundsDetails';
import AuthenticationWindow from '../../CardsPage/AuthenticationWindow';
import {bankingActions} from '../../../../state/actions/banking.actions';
import {transactionActions} from '../../../../state/actions/transaction.actions';
import {SCAActionsConstants} from '../../../../constants';
import {scaHelpers, systemHelpers} from '../../../../utils/helpers';
import {firebaseEvents} from '../../../../snippets/firebase';

const SCA_OPERATION_NAME = SCAActionsConstants.ADD_FUNDS_LOADING;

const AddFundsDetails = ({
  buttonProps = {},
  details = {bic: null, iban: null },
}) => {
  const [t] = useTranslation('main');
  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const [authWindowProps, setAuthWindowProps] = useState({open: false});

  const dispatch = useDispatch();
  const companyBankingUserId = useSelector(state => state.transaction.companyBankingUserId);
  const displayWalletDetailsInitially = useSelector(state => state.main.displayWalletDetailsInitially);

  useEffect(() => {
    if (displayWalletDetailsInitially) {
      loadWalletDetails();
    }
  }, [displayWalletDetailsInitially]); // eslint-disable-line react-hooks/exhaustive-deps

  const loadWalletDetails = () => {
    dispatch(bankingActions.getUserWallets({
      headers: scaHelpers.getAuthHeaders(SCA_OPERATION_NAME),
      id: companyBankingUserId,
      successCallback: (wallets) => {
        if (wallets.length > 0) {
          const wallet = wallets[0];
          dispatch(transactionActions.storeWireDetails(wallet, true));
        } else {
          dispatch(transactionActions.storeWireDetails(undefined));
        }
        setOpenDetailsModal(true);
      },
      errorCallback: (response) => {
        scaHelpers.SCAResponseCallback({
          response,
          scaCallback: (scaProps) => setAuthWindowProps({...authWindowProps, ...scaProps})
        });
      }
    }));
    systemHelpers.logEvent(firebaseEvents.ADD_FUND_BUTTON_CLICK);
  }

  const handleOnClick = (e) => {
    buttonProps?.onClick?.(e);
    loadWalletDetails();
  }

  const handleCloseModal = () => setOpenDetailsModal(false);

  const handleCloseAuthModal = () => setAuthWindowProps({...authWindowProps, open: false});

  const handleOnSuccessAuth = () => {
    handleCloseAuthModal();
    loadWalletDetails();
  }

  return (
    <>
      <StyledAddFundsDetailsButton
        className='primary-outline'
        {...buttonProps}
        onClick={handleOnClick}
      >
        {t('add')} {t('funds')}
      </StyledAddFundsDetailsButton>

      <WireDetailsModal
        details={details}
        onCancel={handleCloseModal}
        onOk={handleCloseModal}
        open={openDetailsModal}
      />

      <AuthenticationWindow
        {...authWindowProps}
        handleCancel={handleCloseAuthModal}
        onSuccess={handleOnSuccessAuth}
        operationName={SCA_OPERATION_NAME}
      />
    </>
  );
}


AddFundsDetails.propTypes = {
  buttonProps: PropTypes.object,
  details: PropTypes.shape({
    bic: PropTypes.string,
    iban: PropTypes.string
  })
}

export default AddFundsDetails;
